import { Component, Input } from '@angular/core';
import { ShowdownDirective } from '../../../directives/animations/showdown.directive';
import { Product } from '../../../models/product';
import { ProductListItem } from '../product-list-item/product-list-item';

@Component({
  selector: 'app-product-list',
  imports: [ShowdownDirective, ProductListItem],
  templateUrl: './product-list.html',
  styleUrl: './product-list.scss',
})
export class ProductList {
  @Input({ required: true }) products: Product[] = [];

  min(a: number, b: number): number {
    return a > b ? b : a;
  }
}
